import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithRedirect } from "features/api/utils/apiUtils.ts";
import endpoints, { baseURL } from "data/api/v1/endpoints.ts";
import { GetPreferencesResponse, GetPreferencesResponseData } from "types/api/preferences/preferences.ts";
import { UpdatePreferencesRequest } from "types/api/preferences/updatePreferences.ts";

export const preferencesApiSlice = createApi({
	reducerPath: "preferencesApi",
	baseQuery: baseQueryWithRedirect(baseURL),
	tagTypes: ["UserPreferences"],
	endpoints: (builder) => ({
		getPreferences: builder.query<GetPreferencesResponseData, void>({
			query: () => endpoints.preferences.userPreferences(),
			transformResponse: (response: GetPreferencesResponse) => response?.data,
			providesTags: ["UserPreferences"]
		}),
		updatePreferences: builder.mutation<GetPreferencesResponseData, UpdatePreferencesRequest>({
			query: (preferences: UpdatePreferencesRequest) => ({
				url: endpoints.preferences.userPreferences(),
				method: "PUT",
				dataType: "json",
				headers: {
					"Content-type": "application/json; charset=UTF-8"
				},
				body: preferences
			}),
			transformResponse: (response: GetPreferencesResponse) => response?.data,
			invalidatesTags: ["UserPreferences"]
		})
	})
});

export const { useGetPreferencesQuery, useUpdatePreferencesMutation } = preferencesApiSlice;
